import {AfterContentInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Consultation} from '../../models/consultation';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {GlobalsService} from '../../globals.service';
import {ConsultationProvider} from '../../providers/consultation.service';
import {EmployeeService} from '../../providers/employee.service';
import {AuthService} from '../../auth/auth.service';
import * as moment from 'moment'
import { IndividualClientService } from 'src/app/providers/client.service';
import { IEmployee } from 'src/app/models/employee';
import { ClientService } from 'src/app/pages/clients/clients.service';

@Component({
  selector: 'consultation-form',
  templateUrl: 'consultation-form.html',
  animations: [
    trigger('flyInOut', [
      state('in', style({transform: 'translateX(0)'})),
      transition('void => *', [
        style({transform: 'translateX(-100%)'}),
        animate('200ms ease-in')
      ]),
      transition('* => void', [
        animate('200ms ease-out', style({transform: 'translateX(100%)'}))
      ])
    ])
  ]
})

export class ConsultationFormComponent implements OnInit, OnChanges, AfterContentInit {

  @Input() consultation: Consultation;
  @Input() addingLateConsultation = false;
  @Input() clientId: number;
  @Input() isEditing: boolean;
  @Input() displayAllEmployees: boolean;
  @Input() sentFrom: string;
  @Output() submission: EventEmitter<{ consultation: Consultation, coachId: number, scheduleSupport: boolean }> = new EventEmitter<{ consultation: Consultation, coachId: number, scheduleSupport: boolean }>();
  @Output() newCoachId: EventEmitter<Number> = new EventEmitter<Number>();
  excuse: string;
  requireComment = false;
  scheduleSupport = false;
  coach: IEmployee;
  coachId: number;
  isSubmitting = false;
  isLoaded = false;
  dateValid: boolean;
  moment = moment
  referrerSearch = '';
  referrerResults: any[] = [];
  referrerName = '';

  constructor( private consultService: ConsultationProvider,
               public globalVarService: GlobalsService,
               private clientService: IndividualClientService,
               private clientsService: ClientService,
               public auth: AuthService,
               public employeeService: EmployeeService ) {
  }

  ngOnInit() {
    console.log(this.auth.getCurrentUser());
    if (this.consultation?.consultation_type === 'info_call') {
      this.consultation.consultation_type = 1
    } else if (this.consultation?.consultation_type === 'initial') {
      this.consultation.consultation_type = 0
    }

    this.consultation.scheduled_post_consultation = this.consultation.scheduled_post_consultation ? true : null
    if (!this.consultation.comment_attributes) {
      this.consultation.comment_attributes = {
        body: '',
        employee_id: this.auth.getCurrentUser().employee?.id,
      }
    }
    this.coach = this.clientService.getClient()?.coach
    this.coachId = this.coach?.id
    if (this.consultation?.referrer_id) {
      this.clientsService.fetchClient(this.consultation.referrer_id, false).subscribe(
        client => this.referrerName = client.name
      );
    }
    console.log(this.consultation)
    console.log(this)
  }

  ngAfterContentInit() {
    this.isLoaded = true
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.consultation) {
      this.consultation = changes.consultation.currentValue;
      const referrerId = this.consultation?.referrer_id;
      if (referrerId && referrerId !== changes.consultation.previousValue?.referrer_id) {
        this.clientsService.fetchClient(referrerId, false).subscribe(
          client => this.referrerName = client.name
        );
      }
    }
    if (this.consultation?.date) {
      this.dateValid = true;
      this.consultation.date = moment(this.consultation.date).format('YYYY-MM-DD')
    }
    this.consultation.scheduled_post_consultation = this.consultation.scheduled_post_consultation ? true : null
  }

  checkForOther(selection) {
    console.log(selection);
    selection === 'not medically eligible' ? this.requireComment = true : this.requireComment = false
  }

  createConsult() {
    this.isSubmitting = true;
    this.consultation.submitted = true;
    if ( !this.consultation.showed_up ) {
      this.consultation.signed_up = false;
      this.consultation.excuse = 'no show'
      this.consultation.cherry_offered = false
    }
    if ( this.consultation.excuse == null ) { this.consultation.excuse = this.excuse }
    // if ( this.addingLateConsultation ) {
    //   // TODO: Remove this
    //   this.consultation.location_id = this.auth.getUser().employee.location.id
    // }
    if (this.consultation.signed_up && this.clientId) {
      this.consultation.client_id = this.clientId
    }

    this.consultService.update(this.consultation).subscribe(
      success => {
        this.submission.emit({ consultation: success, coachId: this.coachId, scheduleSupport: this.scheduleSupport });
        this.isSubmitting = false;
      },
      err => {
        this.globalVarService.handleResponse(err.error, true);
        this.submission.emit();
        this.isSubmitting = false;
      }
    )
  }

  searchReferrer() {
    const val = this.referrerSearch;
    if (val && val.trim() !== '') {
      this.clientsService.clientSearch(val).subscribe(
        clients => {
          console.log(clients);

          this.referrerResults = clients.slice(0, 10)},
        err => this.globalVarService.handleResponse(err.error, true)
      );
    } else {
      this.referrerResults = [];
    }
  }

  selectReferrer(client: any) {
    this.consultation.referrer_id = client.id;
    this.referrerName = client.name;
    this.referrerResults = [];
    this.referrerSearch = '';
  }

  clearReferrer() {
    this.consultation.referrer_id = null;
    this.referrerName = '';
  }

  test($event: { value: string; valid: boolean }) {
    console.log($event, this.consultation)
  }
}
